module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-panel md-scrollbar md-theme-default",
    attrs: {
      "id": "address-types"
    }
  }, [_c('md-content', {
    staticClass: "md-elevation-1",
    attrs: {
      "md-theme": "white"
    }
  }, [_c('div', {
    staticClass: "md-flex",
    attrs: {
      "md-theme": "white"
    }
  }, [_c('sort-table', {
    ref: "table",
    attrs: {
      "columns": _vm.tableColumns,
      "link": "link",
      "table-id": "address-types",
      "per-page": "all"
    },
    on: {
      "refresh": _vm.getAddressTypes
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "actions-wrapper"
        }, [_c('div', {
          staticClass: "actions"
        }, [_c('span', [_c('md-button', {
          staticClass: "md-icon-button md-dense small",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.typeIdToDelete = scope.item.id;
              _vm.deleteDialog = true;
            }
          }
        }, [_c('md-icon', [_vm._v("delete")])], 1), _c('md-tooltip', {
          attrs: {
            "md-direction": "top"
          }
        }, [_vm._v("Удалить")])], 1)])])]
      }
    }]),
    model: {
      value: (_vm.addressTypes),
      callback: function($$v) {
        _vm.addressTypes = $$v
      },
      expression: "addressTypes"
    }
  })], 1), _c('md-button', {
    staticClass: "md-dense",
    attrs: {
      "to": {
        name: 'AddressType',
        params: {
          type_id: 'new'
        }
      }
    }
  }, [_vm._v("Добавить тип адресов "), _c('md-icon', [_vm._v("add")])], 1), _c('md-dialog-confirm', {
    attrs: {
      "md-active": _vm.deleteDialog,
      "md-title": "Удалить тип адресов?",
      "md-content": "Внимание! Действие необратимо!",
      "md-confirm-text": "Удалить",
      "md-cancel-text": "Отмена"
    },
    on: {
      "update:mdActive": function($event) {
        _vm.deleteDialog = $event
      },
      "md-cancel": function($event) {
        _vm.deleteDialog = false;
        _vm.typeIdToDelete = null;
      },
      "md-confirm": _vm.deleteAddressType
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b3ebf50","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/address/views/AddressTypes.vue
// module id = 1175
// module chunks = 0